import { Observable, of } from 'rxjs';

/** Mirrors backend EInvoiceState enum. */
export enum ZatcaInvoiceState {
    None = 'None',
    Generated = 'Generated',
    Pending = 'Pending',
    Uploaded = 'Uploaded',
    Processing = 'Processing',
}

export const ZatcaInvoiceStateTranslations: Record<ZatcaInvoiceState, string> = {
    [ZatcaInvoiceState.None]: 'لم يتم الرفع',
    [ZatcaInvoiceState.Generated]: 'تم الإرسال',
    [ZatcaInvoiceState.Pending]: 'انتظار',
    [ZatcaInvoiceState.Uploaded]: 'تم الرفع',
    [ZatcaInvoiceState.Processing]: 'تمت المعالجة',
};

export const ZatcaInvoiceStateLabelsEn: Record<ZatcaInvoiceState, string> = {
    [ZatcaInvoiceState.None]: 'Not Uploaded',
    [ZatcaInvoiceState.Generated]: 'Sent',
    [ZatcaInvoiceState.Pending]: 'Pending',
    [ZatcaInvoiceState.Uploaded]: 'Uploaded',
    [ZatcaInvoiceState.Processing]: 'Processed',
};

export function getZatcaInvoiceStateLabels(): Observable<
    { labelEn: string; labelAr: string; id: string }[]
> {
    return of(
        (Object.values(ZatcaInvoiceState) as ZatcaInvoiceState[]).map((state) => ({
            id: state,
            labelEn: ZatcaInvoiceStateLabelsEn[state],
            labelAr: ZatcaInvoiceStateTranslations[state],
        }))
    );
}
